import { IServiceProvider, IWindowService } from 'angular';
import { StorageService } from './storage.service';

export class StorageServiceProvider implements IServiceProvider {
  private prefix = '';

  constructor() {
    this.$get.$inject = [ '$window' ];
  }

  public setPrefix( prefix: string ) {
    this.prefix = `${prefix}.`;
  }

  public $get( $window: IWindowService ): StorageService {
    return new StorageService(this.prefix, $window);
  }
}



// WEBPACK FOOTER //
// ./app/core/providers/storage/storage.service.provider.ts